import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 48,
	viewBox: "0 0 70 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 69,
			height: 47,
			rx: 5.5,
			fill: "white",
			stroke: "#D7D5DF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.5 34.3139C33.1169 36.3704 30.0255 37.6119 26.6475 37.6119C19.1102 37.6119 13 31.4308 13 23.806C13 16.1811 19.1102 10 26.6475 10C30.0255 10 33.1169 11.2415 35.5 13.2981C37.8831 11.2415 40.9745 10 44.3525 10C51.8898 10 58 16.1811 58 23.806C58 31.4308 51.8898 37.6119 44.3525 37.6119C40.9745 37.6119 37.8831 36.3704 35.5 34.3139Z",
			fill: "#ED0006"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.5 34.3139C38.4344 31.7816 40.2951 28.0136 40.2951 23.806C40.2951 19.5983 38.4344 15.8303 35.5 13.2981C37.8831 11.2415 40.9745 10 44.3525 10C51.8898 10 58 16.1811 58 23.806C58 31.4308 51.8898 37.6119 44.3525 37.6119C40.9745 37.6119 37.8831 36.3704 35.5 34.3139Z",
			fill: "#F9A000"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.5001 13.2979C38.4345 15.8301 40.2951 19.5981 40.2951 23.8057C40.2951 28.0133 38.4345 31.7813 35.5001 34.3136C32.5657 31.7813 30.7051 28.0133 30.7051 23.8057C30.7051 19.5981 32.5657 15.8301 35.5001 13.2979Z",
			fill: "#FF5E00"
		})
	]
});
export default SvgMastercard;
